import { render, staticRenderFns } from "./female.vue?vue&type=template&id=c3db22c8&scoped=true"
import script from "./female.vue?vue&type=script&lang=js"
export * from "./female.vue?vue&type=script&lang=js"
import style0 from "./female.vue?vue&type=style&index=0&id=c3db22c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3db22c8",
  null
  
)

export default component.exports